import { render } from "./OjtAssessmentReport.vue?vue&type=template&id=20ee492c&scoped=true"
import script from "./OjtAssessmentReport.vue?vue&type=script&lang=js"
export * from "./OjtAssessmentReport.vue?vue&type=script&lang=js"

import "./OjtAssessmentReport.vue?vue&type=style&index=0&id=20ee492c&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ee492c"]])

export default __exports__